<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="80%" :visible.sync="viewData.visible">
    <el-tabs>
        <el-tab-pane :key="1" label="基础信息">
            <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form" size="small">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border>
                        <!-- <el-descriptions-item label="订单编号" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="orderCode">
                                {{dataForm.orderCode}}&nbsp;&nbsp;<el-button v-if="viewFlag !== 'view'" size="small" @click="selectDelivery()">选择</el-button>
                            </el-form-item>
                        </el-descriptions-item> -->
                        <el-descriptions-item label="ASN编码" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="asncode">
                                <span>{{dataForm.asncode}}</span>
                                <!-- <el-input v-else size="mini" v-model="dataForm.asncode" placeholder="ASN编码" clearable></el-input> -->
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="供应商代码" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="supplierCode">
                                <el-input v-show="false" v-model="dataForm.supplierId"></el-input>
                                <span>{{dataForm.supplierCode}}</span>
                                <!-- <el-input v-else size="small" v-model="dataForm.supplierCode" placeholder="供应商代码" clearable></el-input> -->
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="供应商名称" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="supplierName">
                                <span>{{dataForm.supplierName}}</span>
                                <!-- <el-input v-else size="small" v-model="dataForm.supplierName" placeholder="供应商名称" clearable></el-input> -->
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="收货地址" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="deliveryAddress" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view' || this.dataForm.asnStatus === '1' || this.dataForm.asnStatus === '2'">{{dataForm.deliveryAddress}}</span>
                                <el-select v-else v-model="dataForm.deliveryAddress" filterable placeholder="请选择地址">
                                    <el-option v-for="item in streetList" :key="item.street" :label="item.street" :value="item.street">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="供货日期" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="deliveryDate">
                                <span v-if="viewFlag === 'view' || this.dataForm.asnStatus === '1' || this.dataForm.asnStatus === '2'">
                                    {{ dateFormatValue(dataForm.deliveryDate) }}
                                </span>
                                <el-date-picker v-else v-model="dataForm.deliveryDate" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="预计到达日期" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="recieveyDate">
                                <span v-if="viewFlag === 'view' || this.dataForm.asnStatus === '1' || this.dataForm.asnStatus === '2'">
                                    {{ dateFormatValue(dataForm.recieveyDate) }}
                                </span>
                                <el-date-picker v-else v-model="dataForm.recieveyDate" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="ASN状态" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="asnStatus">
                                <span>{{getAsnStatusByValue(dataForm.asnStatus)}}</span>
                                <!-- <el-select v-else size="small" v-model="dataForm.asnStatus" placeholder="请选择ASN状态" clearable>
                                    <el-option v-for="item in ASN_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select> -->
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="备注" :label-style="getStyle()">
                            <el-form-item style="margin-bottom: 0;" prop="remark">
                                <span v-if="viewFlag === 'view' || this.dataForm.asnStatus === '1' || this.dataForm.asnStatus === '2'">{{dataForm.remark}}</span>
                                <el-input v-else type="textarea" :rows="3" size="small" v-model="dataForm.remark" placeholder="" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
                <el-row :gutter="10">
                    <el-col :span="24" style="padding: 15px">
                        <div>
                            注：1.送货单需保存两联； 2.签字栏必须是签字，不可盖章。
                        </div>
                        <hr />
                        <div style="line-height: 1.5;">
                            送货单流程：<br />
                            1. 供应商生成四联送货单，签字完成<br />
                            2. 司机带上四联送货单<br />
                            3.
                            到达到货地点，厂内物流验货完成填写实收数量，并签字确认，司机确认收货数量并签字<br />
                            4.
                            厂内物流保存第2，3联；第1、4联由司机带走，返回供应商<br />
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </el-tab-pane>
        <el-tab-pane :key="2" label="零件清单">
            <el-row :gutter="10">
                <el-col :span="24">
                    <div style="float: right;" v-if="isAuth('sourcing:delivery:newbutton') && viewFlag !== 'view'">
                        <el-button v-if="isAuth('sourcing:delivery:newbutton')" :loading="handleSaveLoading" @click="handleSave()" icon='el-icon-edit' size='small' type="primary" :disabled="!dataForm.id">
                            保存零件信息
                        </el-button>
                        <el-button size="small" v-if="isAuth('sourcing:delivery:newbutton')" type="primary" @click="selectPartList()" icon="el-icon-plus" :disabled="!dataForm.id" class="mb15">
                            选择零件信息
                        </el-button>
                    </div>
                    <span style="color: red;font-size: 12px;float:left;line-height: 30px;margin-right: 20px;" v-if="isAuth('sourcing:delivery:newbutton') && viewFlag !== 'view'">* 双击表格进行编辑</span>
                    <el-table-edit :model="deviveryPartList" :columns="['orderCode','partCode','partName','boxType','inCount','deliveredBoxCount','deliveredCount','unit','batchNumber','recieveCount','remark']" ref="editTable">
                        <el-table :data="deviveryPartList" row-key="id" size="small" border :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" @cell-dblclick="editAll" style="width: 100%">
                            <!-- <el-table-column type="index" width="50" label="序号">
                            </el-table-column> -->
                            <!-- <el-table-column prop="zexpos" header-align="center" align="right" label="SRM项目" width="80">
                                <template slot-scope="scope">
                                    <span>{{scope.row.zexpos = ((pageIndex - 1) * pageSize) + scope.$index + 1}}</span>
                                </template>
                            </el-table-column> -->
                            <!-- 供应商填写 -->
                            <el-table-column prop="orderCode" header-align="center" align="left" label="订单编码" width="150">
                            </el-table-column>
                            <el-table-column prop="ebeln" header-align="center" align="left" label="采购订单号" width="150">
                            </el-table-column>
                            <!-- <el-table-column prop="asncode" header-align="center" align="left" label="ASN编码">
                        </el-table-column> -->
                            <!-- 供应商填写 -->
                            <el-table-column prop="partCode" header-align="center" align="left" label="物料号" width="150">
                            </el-table-column>
                            <!-- 供应商填写 -->
                            <el-table-column prop="partName" header-align="center" align="left" label="零件名称" width="150">
                            </el-table-column>
                            <!-- 交货数量 -->
                            <el-table-column prop="lfimg" header-align="center" align="left" label="交货数量" width="151">
                                <template slot-scope="scope">
                                    <ctl-number :min="0" :max="999" size="small" v-if="scope.row.show" v-model="scope.row.lfimg" placeholder="交货数量"></ctl-number>
                                    <span v-else>{{scope.row.lfimg}}</span>
                                </template>
                            </el-table-column>
                            <!-- 单位 -->
                            <el-table-column prop="unit" header-align="center" align="center" label="单位" width="150">
                                <template slot-scope="scope">
                                    <!-- <el-input size="small" v-if="scope.row.show" v-model="scope.row.unit" placeholder="单位"></el-input> -->
                                    <!-- <el-select v-if="scope.row.show" v-model="scope.row.unit" filterable placeholder="请选择">
                                        <el-option v-for="item in unitList" :key="item.code" :label="item.name" :value="item.code">
                                        </el-option>
                                    </el-select> -->
                                    <span>{{getUnitName(scope.row.unit)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="meins" header-align="center" align="center" label="基本计量单位" width="150">
                                <template slot-scope="scope">
                                    <!-- <el-select v-if="scope.row.show" v-model="scope.row.unit" filterable placeholder="请选择">
                                        <el-option v-for="item in unitList" :key="item.code" :label="item.name" :value="item.code">
                                        </el-option>
                                    </el-select> -->
                                    <span>{{scope.row.meins}}</span>
                                </template>
                            </el-table-column>
                            <!-- 供应商填写 -->
                            <el-table-column prop="hsdat" header-align="center" align="left" label="生产日期" width="241">
                                <template slot-scope="scope">
                                    <el-date-picker size="small" v-if="scope.row.show" v-model="scope.row.hsdat" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                                    </el-date-picker>
                                    <span v-else>{{ dateFormatValue(scope.row.hsdat) }}</span>
                                </template>
                            </el-table-column>
                            <!-- 供应商填写 -->
                            <el-table-column prop="vfdat" header-align="center" align="left" label="货架寿命到期日" width="241">
                                <template slot-scope="scope">
                                    <el-date-picker size="small" v-if="scope.row.show" v-model="scope.row.vfdat" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                                    </el-date-picker>
                                    <span v-else>{{ dateFormatValue(scope.row.vfdat) }}</span>
                                </template>
                            </el-table-column>
                            <!-- 供应商填写 -->
                            <el-table-column prop="lichn" header-align="center" align="left" label="供应商批次编号" width="150">
                                <template slot-scope="scope">
                                    <el-input size="small" v-if="scope.row.show" v-model="scope.row.lichn" placeholder="供应商批次编号"></el-input>
                                    <span v-else>{{scope.row.lichn}}</span>
                                </template>
                            </el-table-column>
                            <!-- 供应商填写（纸箱、货架等） -->
                            <el-table-column prop="boxType" header-align="center" align="left" label="箱种" width="150">
                                <template slot-scope="scope">
                                    <el-input size="small" v-if="scope.row.show" v-model="scope.row.boxType" placeholder="箱种"></el-input>
                                    <span v-else>{{scope.row.boxType}}</span>
                                </template>
                            </el-table-column>
                            <!-- 供应商填写 -->
                            <el-table-column prop="inCount" header-align="center" align="right" label="收容数" width="151">
                                <template slot-scope="scope">
                                    <ctl-number :min="0" :max="999" size="small" v-if="scope.row.show" v-model="scope.row.inCount" placeholder="收容数"></ctl-number>
                                    <span v-else>{{scope.row.inCount}}</span>
                                </template>
                            </el-table-column>
                            <!-- 供应商填写 -->
                            <el-table-column prop="deliveredBoxCount" header-align="center" align="right" label="送货箱数" width="151">
                                <template slot-scope="scope">
                                    <ctl-number :min="0" :max="999" size="small" v-if="scope.row.show" v-model="scope.row.deliveredBoxCount" placeholder="送货箱数"></ctl-number>
                                    <span v-else>{{scope.row.deliveredBoxCount}}</span>
                                </template>
                            </el-table-column>
                            <!-- 供应商填写 -->
                            <el-table-column prop="deliveredCount" header-align="center" align="right" label="送货数量" width="151">
                                <template slot-scope="scope">
                                    <ctl-number :min="0" :max="999" size="small" v-if="scope.row.show" v-model="scope.row.deliveredCount" placeholder="送货数量"></ctl-number>
                                    <span v-else>{{scope.row.deliveredCount}}</span>
                                </template>
                            </el-table-column>
                            <!-- 供应商选填（生产批次） -->
                            <el-table-column prop="batchNumber" header-align="center" align="left" label="批号" width="150">
                                <template slot-scope="scope">
                                    <el-input size="small" v-if="scope.row.show" v-model="scope.row.batchNumber" placeholder="批号"></el-input>
                                    <span v-else>{{scope.row.batchNumber}}</span>
                                </template>
                            </el-table-column>
                            <!-- 厂内物流填写 -->
                            <!-- <el-table-column prop="recieveCount" header-align="center" align="right" label="实收数量" width="151">
                                <template slot-scope="scope">
                                    <ctl-number :min="0" :max="999" size="small" v-if="scope.row.show" v-model="scope.row.recieveCount" placeholder="实收数量"></ctl-number>
                                    <span v-else>{{scope.row.recieveCount}}</span>
                                </template>
                            </el-table-column> -->
                            <el-table-column prop="zid" header-align="center" align="left" label="SRM到货单" width="150">
                                <template slot-scope="scope">
                                    <el-input size="small" v-if="scope.row.show" v-model="scope.row.zid" placeholder="SRM到货单"></el-input>
                                    <span v-else>{{scope.row.zid}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="ebelp" header-align="center" align="left" label="采购订单项目" width="150">
                                <template slot-scope="scope">
                                    <!-- <el-input size="small" v-if="scope.row.show" v-model="scope.row.ebelp" placeholder="采购订单项目"></el-input> -->
                                    <span>{{scope.row.ebelp}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="werks" header-align="center" align="left" label="工厂" width="150">
                                <template slot-scope="scope">
                                    <!-- <el-select v-if="scope.row.show" v-model="scope.row.werks" filterable placeholder="请选择工厂">
                                        <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                                        </el-option>
                                    </el-select> -->
                                    <span>{{ getFactoryName(scope.row.werks) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" header-align="center" align="left" label="备注" width="150">
                                <template slot-scope="scope">
                                    <el-input size="small" v-if="scope.row.show" v-model="scope.row.remark" placeholder="备注"></el-input>
                                    <span v-else>{{scope.row.remark}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="viewFlag !== 'view'" header-align="center" align="center" width="100" label="操作">
                                <template slot-scope="scope">
                                    <!-- <el-button type="text" size="small" @click="
                                        addOrUpdateDeliveryPartHandle(
                                            scope.row.id
                                        )
                                    " icon="el-icon-edit">
                                    修改
                                </el-button> -->
                                    <el-button type="danger" size="mini" @click="
                                        deleteHandlePart(scope.row.id)
                                    " icon="el-icon-delete">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-table-edit>
                </el-col>
            </el-row>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" class="mb15">
            </el-pagination>
        </el-tab-pane>
        <el-tab-pane :key="3" label="附件文件">
            <!-- TODO:上传下载 产看 需求文档 -->
            <FilesUpDown ref="FilesUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown>
        </el-tab-pane>
    </el-tabs>
    <div v-if="isAuth('sourcing:delivery:newbutton') && viewFlag !== 'view'">
        <el-row :gutter="40">
            <el-col :span="24" style="text-align: right">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <!-- 供应商 -->
                <template v-if="isAuth('sourcing:supplier:button')">
                    <el-button size="small" type="primary" @click="dataFormSave()">
                        保存
                    </el-button>
                    <el-button size="small" type="success" :loading="handleSaveLoading" @click="dataFormSubmit()">
                        提交审核
                    </el-button>
                </template>
                <!-- 生准物流 -->
                <template v-if="isAuth('sourcing:sgwl:button')">
                    <el-button size="small" type="success" @click="dataFormPass()">
                        通过
                    </el-button>
                    <el-button size="small" type="danger" @click="dataFormReject()">
                        驳回
                    </el-button>
                    <!-- 内向交货单 -->
                    <el-button size="small" type="primary" @click="dataFormSync()">
                        同步SAP
                    </el-button>
                </template>
            </el-col>
        </el-row>
    </div>

    <!-- 弹窗, 新增 / 修改 零件-->
    <add-or-update-delivery-part v-if="addOrUpdateDeliveryPartVisible" ref="addOrUpdateDeliveryPart" @refreshDeliveryPartDataList="getDeliveryPartList"></add-or-update-delivery-part>
    <select-order-part v-if="selectOrderPartVisible" :partFormData="dataForm" ref="selectOrderPart" @refreshDeliveryPartDataList="getDeliveryPartList"></select-order-part>
</el-dialog>
</template>

<script>
import Vue from 'vue'
import {
    getStreetList
} from '@/controller/order'
import {
    ASN_STATUS,
    DIALOG_CLOSED_TYPE,
    getAsnStatusByValue
} from "@/utils/const";
import {
    getDeliveryById,
    editDelivery,
    createDelivery,
    getDeliveryPartList,
    deletePartList,
    saveDeliveryPart,
    saveDeliveryPartList
} from "@/controller/delivery";
import {
    getUnitList,
    getFactoryList
} from '@/controller/systemData'
import FilesUpDown from "@/views/common/file-up-down";
import AddOrUpdateDeliveryPart from "./delivered-appart-add-or-update";
import SelectOrderPart from "./select-order-part"
import moment from 'moment'
import CtlNumber from '@/views/common/ctl-number'
export default {
    props: {
        partFormData: Object,
    },
    data() {
        return {
            handleSaveLoading: false,
            show: false,
            FILE_BIZ_TYPE: 11,
            viewFlag: '',
            viewData: {
                visible: false,
                width: "",
            },
            ASN_STATUS: ASN_STATUS,
            DIALOG_CLOSED_TYPE: DIALOG_CLOSED_TYPE,
            getAsnStatusByValue: getAsnStatusByValue,
            dataList: [],
            unitList: [],
            factoryList: [],
            streetList: [],
            pageIndex: 1,
            pageSize: 50,
            totalPage: 0,
            deviveryPartList: [],
            addOrUpdateDeliveryPartVisible: false,
            selectOrderPartVisible: false,
            dataForm: {
                id: 0,
                asncode: '',
                supplierCode: '',
                supplierName: '',
                deliveryAddress: '',
                recieveyDate: '',
                deliveryDate: '',
                asnStatus: '',
                remark: '',
                deliveryId: ''
            },
            dataRule: {
                name: [{
                    required: true,
                    message: "组织名称不能为空",
                    trigger: "blur",
                }, ],
                code: [{
                    required: true,
                    message: "组织代码不能为空",
                    trigger: "blur",
                }, ],
                tenantName: [{
                    required: true,
                    message: "请先在页面顶部导航栏选择租户",
                    trigger: "blur",
                }, ],
            },
        };
    },
    mounted() {},
    components: {
        AddOrUpdateDeliveryPart,
        SelectOrderPart,
        FilesUpDown, // 附件上传
        CtlNumber
    },
    computed: {
        editTable() {
            return this.$refs.editTable
        }
    },
    methods: {
        editAll() {
            //debugger
            console.log("111")
            this.deviveryPartList.map((i, index) => {
                i.show = true
                Vue.set(this.deviveryPartList, index, i)
            })
        },
        handleSave() {
            //调用保存方法
            this.saveData(this.deviveryPartList)
            console.log(this.deviveryPartList,'地址1')
        },
        saveData(list) {
            this.handleSaveLoading = true
            console.log(list,'地址2')
            saveDeliveryPartList(
                list
                //deliveryId: this.deliveryId,
            ).then(data => {
                if (data && data.code === '00') {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                    })
                    this.getDeliveryPartList()
                    this.handleSaveLoading = false
                } else {
                    this.handleSaveLoading = false
                    this.$message.error(data.msg)
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.handleSaveLoading = false
            })
        },
        init(data, id, viewFlag) {
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0;
            this.deviveryPartList = [];
            this.viewData.visible = true;
            this.$nextTick(() => {
                //初始化上传附件
                this.$refs.FilesUpDown.init(id, this.FILE_BIZ_TYPE, null);
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id找订单对象
                    getDeliveryById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm.asncode = data.body.asncode;
                            this.dataForm.supplierCode = data.body.supplierCode;
                            this.dataForm.supplierName = data.body.supplierName;
                            this.dataForm.deliveryAddress = data.body.deliveryAddress;
                            this.dataForm.recieveyDate = data.body.recieveyDate;
                            this.dataForm.deliveryDate = data.body.deliveryDate;
                            this.dataForm.asnStatus = data.body.asnStatus;
                            this.dataForm.remark = data.body.remark;

                        }
                    });
                }
            });
            if (this.dataForm.id) {
              this.getDeliveryPartList();
            }
            this.getUnitList();
            this.getFactoryList();
            this.getStreetList()
        },
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.factoryDesc = ""
            })
        },
        getStreetList() {
            getStreetList({
                street: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.streetList = data.body.records;
                }
            })
        },
        setFactoryName(val) {
            console.log(val)
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            this.dataForm.deliveryAddress = factory ? factory.address : ''
        },
        getFactoryName(val) {
            console.log(val)
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            return factory ? factory.factoryDesc : ''
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        getTaxCodeName(code) {
            const taxCode = this.unitList.find(taxCode => taxCode.code === code)
            return taxCode ? taxCode.name : ''
        },
        selectPartList(id) {
            this.selectOrderPartVisible = true;
            this.$nextTick(() => {
                // const _this = this
                const ids = []
                this.deviveryPartList.forEach(part => {
                    ids.push(part.deliveryId)
                });
               // this.$refs.selectOrderPart.open(ids);
               this.$refs.selectOrderPart.open(this.dataForm.deliveryAddress);
                this.$refs.selectOrderPart.onClosed = (payload) => {
                    if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                        this.getDeliveryPartList()
                    }
                };
            });
        },
        // 查所有订单零件表
        getDeliveryPartList() {
            getDeliveryPartList({
                deliveryId: this.dataForm.id,
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.deviveryPartList = data.body.records;
                    this.totalPage = data.body.total
                } else {
                    this.deviveryPartList = [];
                    this.totalPage = 0
                }
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDeliveryPartList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDeliveryPartList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 新增 / 修改 零件表
        addOrUpdateDeliveryPartHandle(id) {
            this.addOrUpdateDeliveryPartVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdateDeliveryPart.init(
                    id,
                    this.dataForm.id
                );
            });
        },
        // 删除零件
        deleteHandlePart(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deletePartList({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDeliveryPartList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        dateFormatValue: function (value) {
            if (value == undefined) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        // dateFormat: function (row, column) {
        //     var date = row[column.property]
        //     if (date == undefined) {
        //         return ''
        //     }
        //     return moment(date).format("YYYY-MM-DD前")
        // },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    this.handleSaveLoading = true
                    let deliveryParams = {
                        id: this.dataForm.id || undefined,
                        'asncode': this.dataForm.asncode,
                        'supplierCode': this.dataForm.supplierCode,
                        'supplierName': this.dataForm.supplierName,
                        'deliveryAddress': this.dataForm.deliveryAddress,
                        'recieveyDate': this.dataForm.recieveyDate,
                        'deliveryDate': this.dataForm.deliveryDate,
                        'asnStatus': '1',
                        'remark': this.dataForm.remark,
                    };
                    if (this.dataForm.id) {
                        editDelivery(deliveryParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "ASN交货单修改成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.viewData.visible = false;
                                            this.$emit("refreshDataList");
                                            this.handleSaveLoading = false
                                        },
                                    });

                                } else {
                                    this.handleSaveLoading = false
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                                this.handleSaveLoading = false
                            }).finally(() => {
                                this.handleSaveLoading = false
                            });
                    }
                }
            });
        },
        dataFormSave() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let deliveryParams = {
                        id: this.dataForm.id || undefined,
                        'asncode': this.dataForm.asncode,
                        'supplierCode': this.dataForm.supplierCode,
                        'supplierName': this.dataForm.supplierName,
                        'deliveryAddress': this.dataForm.deliveryAddress,
                        'recieveyDate': this.dataForm.recieveyDate,
                        'deliveryDate': this.dataForm.deliveryDate,
                        'asnStatus': '0',
                        'remark': this.dataForm.remark,
                    };
                    if (this.dataForm.id) {
                        editDelivery(deliveryParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.dataForm = data.body
                                    this.$message({
                                        message: "ASN交货单修改成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            // this.viewData.visible = false;
                                            this.$emit("refreshDataList");
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        createDelivery(deliveryParams).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body
                                this.$message({
                                    message: "ASN交货单创建成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        // this.viewData.visible = false;
                                        this.$emit("refreshDataList");
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                }
            });
        },
        dataFormPass() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let deliveryParams = {
                        id: this.dataForm.id || undefined,
                        'asncode': this.dataForm.asncode,
                        'supplierCode': this.dataForm.supplierCode,
                        'supplierName': this.dataForm.supplierName,
                        'deliveryAddress': this.dataForm.deliveryAddress,
                        'recieveyDate': this.dataForm.recieveyDate,
                        'deliveryDate': this.dataForm.deliveryDate,
                        'asnStatus': '2',
                        'remark': this.dataForm.remark,
                    };
                    if (this.dataForm.id) {
                        editDelivery(deliveryParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "邮件发送成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.viewData.visible = false;
                                            this.$emit("refreshDataList");
                                        },
                                    });

                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        dataFormReject() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let deliveryParams = {
                        id: this.dataForm.id || undefined,
                        'asncode': this.dataForm.asncode,
                        'supplierCode': this.dataForm.supplierCode,
                        'supplierName': this.dataForm.supplierName,
                        'deliveryAddress': this.dataForm.deliveryAddress,
                        'recieveyDate': this.dataForm.recieveyDate,
                        'deliveryDate': this.dataForm.deliveryDate,
                        'asnStatus': '3',
                        'remark': this.dataForm.remark,
                    };
                    if (this.dataForm.id) {
                        editDelivery(deliveryParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "邮件发送成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.viewData.visible = false;
                                            this.$emit("refreshDataList");
                                        },
                                    });

                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        getStyle() {
            return 'width: 100px; text-align: right'
        },
        getStyle2() {
            return 'width: 647.5px;'
        }
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.button-danger {
    color: #F56C6C
}

.linetext {
    white-space: pre-line;
}

.mb15 {
    margin-bottom: 15px;
}

.el-table__body td {
    user-select: none;
}
</style>
